import { useQuery } from '@tanstack/react-query';
import { notificationApi } from '../api/notification.api';
import { notificationKeys } from '../api/notification.keys';

export function useNotificationDetails(id: any) {
  return useQuery({
    queryKey: notificationKeys.detail(id),
    queryFn: () => notificationApi.getById(id),
    enabled: !!id,
  });
}
